import React from 'react';

import { ReactProps } from '../../typings/common-types';

import Icon, { IconProps } from './icon';

const svg = (props: ReactProps) => (
    <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
        <path d="M40 0c22.091 0 40 17.909 40 40S62.091 80 40 80 0 62.091 0 40 17.909 0 40 0zm0 74.286c18.935 0 34.286-15.35 34.286-34.286 0-18.935-15.35-34.286-34.286-34.286C21.065 5.714 5.714 21.064 5.714 40c0 18.935 15.35 34.286 34.286 34.286zm.952-58.096a2.857 2.857 0 0 1 2.858 2.858v26.666a2.857 2.857 0 1 1-5.715 0V19.048a2.857 2.857 0 0 1 2.857-2.858zm0 42.858a2.857 2.857 0 1 1 0-5.715 2.857 2.857 0 0 1 0 5.715z" fill="currentColor" fillRule="evenodd"></path>
    </svg>
);

const IconAlert: React.FC<IconProps> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconAlert;
